jQuery(document).ready(function($) {
    var prev = $( "#partners-carousel #previous" ); // the previous control
    var next = $( "#partners-carousel #next" ); // the next control
    var carousel = $( "#partners-carousel .gallery-item" ); // the images
    var count = carousel.length; // how many images?
    var i, interval;
    var speed = 3000;
    var transition = 500;
    
    // set the images width
    width = $( "#partners-carousel" ).outerWidth();
    carousel.each( function() { $( this ).css( "width", width ); } );
    
    // set the gallery width
    $( "#partners-carousel .gallery" ).css( "width", count * width );
    
    // Start animation
    start_carousel( -1 );
    
    // Click trigger for switching image
    prev.on( 'click', function() { start_carousel( i - 2 ); } );
    next.on( 'click', function() { start_carousel( i ); } );
    
    function show_next() {
        i++;
        if( i >= count ) i = 0; // go to the begining
        else if( i < 0 ) i = count - 1;
        $( "#partners-carousel" ).scrollTo( carousel.eq( i ), transition );
    }
    
    function start_carousel( pos ) {
        if( interval) clearInterval( interval );
        i = pos;
        show_next();
        interval = setInterval( show_next, speed );
    }
    
});
